/**
 * Fallback brand colors used when a published theme leaves the field empty.
 * Every consumer reads them from here so the theme stylesheet and the components
 * that recompute a color from the same source cannot drift apart.
 */
export const DEFAULT_HEADLINE_COLOR = '#016fe6';
